// extracted by mini-css-extract-plugin
module.exports = {"root":"MultiRowSelect_root__3X0fI"};